import { createContext, useContext } from 'react';
import { IAllTasksFilters } from '../types';

type MyContextType = {
  filters: IAllTasksFilters;
  handleFilterChange: (filters: Partial<IAllTasksFilters>) => void;
  completedFilters: IAllTasksFilters;
  handleCompletedFilterChange: (filters: Partial<IAllTasksFilters>) => void;
  selectedTaskId: string;
  handleCloseDrawer: () => void;
  handleOpenTaskDetails: (taskId: string) => void;
  handleFullResetCompletedFilters: () => void;
  handleFullResetIncompleteFilters: () => void;
  isFiltersCardOpen: boolean;
  handleCloseFiltersCard: () => void;
  handleToggleFiltersCard: () => void;
};

export const AllWorklistContext = createContext<MyContextType | null>(null);

export const useAllWorklistContext = () => {
  const context = useContext(AllWorklistContext);
  if (!context) {
    throw new Error(
      'The useAllWorklistContext hook must be used within a AllWorklistContextProvider.',
    );
  }
  return context;
};
